import React from 'react';
import ChartGroup from './Chart_Of_Group';
import '../../../CommonCSS/SocietyCSS.css'

const ChartGrpApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Chart Of Groups</h5>
          </div>
        </div>
        <ChartGroup />
      </div>
    </div >
  );
};

export default ChartGrpApp;
